import { IconButton } from '@affine/component';
import { PlusIcon } from '@blocksuite/icons/rc';
import clsx from 'clsx';
import { type ComponentProps, forwardRef } from 'react';

import * as styles from './index.css';

type IconButtonProps = ComponentProps<typeof IconButton>;

export interface SidebarCreateButtonProps extends Omit<
  IconButtonProps,
  'children' | 'size' | 'tooltip'
> {
  label: string;
  testId?: string;
}

/** Shared visual create action for Workspace, Planner, Mail, and other app sidebars. */
export const SidebarCreateButton = forwardRef<
  HTMLButtonElement,
  SidebarCreateButtonProps
>(({ className, label, testId, tooltipOptions, ...buttonProps }, ref) => (
  <IconButton
    {...buttonProps}
    ref={ref}
    aria-label={buttonProps['aria-label'] ?? label}
    className={clsx(styles.root, className)}
    data-testid={testId}
    size="16"
    tooltip={label}
    tooltipOptions={tooltipOptions}
  >
    <PlusIcon />
  </IconButton>
));

SidebarCreateButton.displayName = 'SidebarCreateButton';
